module.exports = __webpack_public_path__ + "img/logo-white.21f41252.png";